import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import logger from "redux-logger";
import thunk from "redux-thunk";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import reducers from "./reducers";
import { getReduxPersistKey } from "../utilities/appSessionKey";

const persistConfig = {
  // Isolate each app/instance session so multi-tab HOMS + HPRMS do not collide.
  key: getReduxPersistKey(),
  storage,
  // Keep session + tenant config across browser refresh (for THIS app/instance only)
  whitelist: ["authReducer", "usersState", "globalState"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(logger, thunk))
);

export const persistor = persistStore(store);

export default store;
